// region Offer Terms Modal Button
$(document).on('click', '.js-offer-modal-btn', function (event) {
    event.preventDefault();

    let $this = $(this);
    let modalElement = $('.js-offer-modal');

    $.ajax({
        method: 'get',
        dataType: 'json',
        url: $this.attr('href'),
        success: function (response) {
            modalElement.html('');

            if (response.success) {
                modalElement.append(response.content);
            }

            modalElement.find('.modal').modal('show');
        }
    });
});
// endregion

function setQueryStringParameter(name, value) {
    const params = new URLSearchParams(window.location.search);
    params.set(name, value);
    window.history.replaceState({}, "", decodeURIComponent(`${window.location.pathname}?${params}`));
}

/* region Select/Remove Filter */
$(document).on('click', '.facets .js-toggle-filter, .js-search-page .js-toggle-filter, .js-search-page .js-remove-filter', function () {
    let url = $(this).attr('data-url');

    if (!$(this).hasClass('disabled')) {
        if (url) {
            window.location = url;
        }
    }
});
/* endregion */

/* region Toggle Filter Children */
$(document).on('click', '.has-children:not(.checkbox-container)', function () {
    $(this).toggleClass('active').next().slideToggle();
});
/* endregion */

// region Sort Select
$(document).on('change', 'select.sortBy', function () {
    let url = $(this).val();
    if (url) {
        window.location = url;
    }
});
// endregion

// region Load More - Search Page
$(document).on('click', '.js-load-more', function () {
    let $this = $(this);

    $('.loading-icon').show();

    $.ajax({
        method: 'GET',
        dataType: 'json',
        url: $(this).attr('data-url'),
        success: function (response) {
            if (response.data) {
                $('.js-current-total').text(response.count);
                $this.attr('data-url', response.next_link)

                $('.loading-icon').hide();

                // region Remove focus
                $this.focus(function () {
                    this.blur();
                });
                // endregion

                $('.js-list-results').append(response.data);

                // region Call lazyload again
                $('.lazyload-bg').each(function () {
                    let lazy = $(this);
                    let src = lazy.attr('data-src');
                    lazy.css('background-image', 'url("' + src + '")');
                    lazy.removeAttr('data-src');
                    lazy.removeClass('lazyload-bg');
                });
                // endregion

                setQueryStringParameter('page', response.current_page);

                if (response.next_link !== '') {
                    $this.remove();
                }
            } else {
                $this.remove();
            }
        }
    });
});
// endregion

// region Top search - suggestions dropdown
let f = -1;
let xhr;

$(document).on('keyup paste', '.js-search-field', function (event) {
    if (event.keyCode === 40 || event.keyCode === 38 || event.keyCode === 13 || event.keyCode === 39 || event.keyCode === 37) {
        event.preventDefault();
        return false;
    }
    let $form = $(this).closest('form');
    let suggestionList = $form.find('.js-suggestions-list');

    let searchTerm = $(this).val().replace('[^a-zA-Z0-9\'\s]', '');
    let searchType = $form.find('.search-type');

    if (xhr) {
        xhr.abort();
    }

    xhr = $.ajax({
        method: 'GET',
        dataType: 'json',
        data: {s: searchTerm},
        url: $(this).attr('data-url'),
        success: function (response) {
            if (response.data.length > 0) {
                let html = '';
                $(response.data).each(function () {
                    html += this.list_html;
                });
                suggestionList.html(html);
                suggestionList.addClass('active').show();
            } else {
                suggestionList.removeClass('active').html('').hide();
                f = -1;
            }

            searchType.val(response.type);

            // Postcode
            if (response.type === 'postcode' && response.coordinates.lat && response.coordinates.lng) {
                $('input[name="coordinates"]').val(response.coordinates.lat + ',' + response.coordinates.lng);
            }
        }
    });

})
    .on('keydown', '.js-search-field', function (e) {
        let $form = $(this).closest('form');
        let suggestionList = $form.find('.js-suggestions-list');

        /*If the arrow DOWN key*/
        if (e.keyCode === 40) {
            f++;
            currentItem(suggestionList);
        } else if (e.keyCode === 38) {
            /*If the arrow UP key is pressed*/
            f--;
            currentItem(suggestionList);
        } else if (e.keyCode === 13) {
            /*If the ENTER key is pressed*/
            e.preventDefault();

            if (f > -1) {
                /*and simulate a click on the "active" item:*/
                suggestionList.find('.item.active').trigger('click');
            } else {
                $('.js-search-btn').trigger('click');
            }
        }
    });

// Hide the auto complete box
$(document).on('click', function () {
    let suggestionList = $('.js-suggestions-list');

    if (suggestionList.find('.item').length && suggestionList.hasClass('active')) {
        suggestionList.empty();
        f = -1;
        suggestionList.hide();
    }
});

function currentItem(element) {
    element.find('.item.active').removeClass('active');
    let t = element.find('.item').length;
    if (f >= t) {
        f = 0;
    }

    if (f < 0) {
        f = (t - 1);
    }

    element.find('.item').eq(f).addClass('active').focus();
}

function menu_item_link(element) {
    window.location = $(element).attr('data-url');
}

$(document).on('click', '.item.active', function () {
    menu_item_link(this);
});

$(document).on('click', '.js-suggestions-list .item', function () {
    menu_item_link(this);
});

// endregion

$(document).on('click', '.js-filters-modal', function () {
    $.ajax({
        method: 'GET',
        dataType: 'json',
        url: $('.js-filters-modal-container').attr('data-url'),
        data: {route: $('.js-filters-modal-container').attr('data-route')},
        success: function (response) {
            $('.js-filters-modal-container').attr('data-url', response.facetUrl);
            $('body').addClass('modal-open');

            let $filterModalContainer = $('.js-filters-modal-container');
            $filterModalContainer.html(response.facet);
            $filterModalContainer.css({display: 'block', height: $(window).height()});
        }
    });
});

$(document).on('click', '.js-close-filter-modal', function (event) {
    event.preventDefault();

    $('body').removeClass('modal-open');

    let $filterModalContainer = $('.js-filters-modal-container');
    $filterModalContainer.html('');
    $filterModalContainer.css({display: 'none', height: $(window).height()});
});

// #########################################################

// Element
let $localSearchMap = $('.local-search-map');
let $zeroAlert = $('.zero-alert');
let $redraw = $('#redraw');

// Init Vars
let markers, bounds, infoWindow, map, lat, lng, coords;

function initMap() {
    //  from initial page load
    lat = parseFloat($('#local-search-map input[name="latitude"]').val());
    lng = parseFloat($('#local-search-map input[name="longitude"]').val());

    //  make google maps friendly
    coords = {lat: lat, lng: lng};

    $zeroAlert.hide();

    if ($localSearchMap.length > 0) {
        bounds = new google.maps.LatLngBounds();
        infoWindow = new google.maps.InfoWindow();

        map = new google.maps.Map($localSearchMap[0], {
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            center: coords,
            zoom: 12,
            styles: [
                {
                    featureType: "poi",
                    elementType: "labels",
                    stylers: [
                        {
                            visibility: "off"
                        }
                    ]
                }
            ]
        });

        if ("geolocation" in navigator) {
            navigator.geolocation.getCurrentPosition(function (position) {
                let pos = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };

                $('#local-search-map input[name="lat"]').val(position.coords.latitude)
                $('#local-search-map input[name="lng"]').val(position.coords.longitude)
                map.setCenter(pos);
                // submitRequest();
            }, showGeoError);
        }

        addSearchedMarker(coords);

        // region Event Listener
        google.maps.event.addListener(map, 'idle', function () {
            $('#sw-lat').val(map.getBounds().getSouthWest().lat());
            $('#sw-lng').val(map.getBounds().getSouthWest().lng());
            $('#ne-lat').val(map.getBounds().getNorthEast().lat());
            $('#ne-lng').val(map.getBounds().getNorthEast().lng());

            // some events do not require a reload of data (eg. infoWindow popup that moves the map)
            if (parseInt($redraw.val(), 10) === 1) {
                submitRequest();
            }

            //  in case we set not to redraw last time around, set it back to true
            $redraw.val(1);
        });
        // endregion
    }
}

window.initMap = initMap;

/**
 * This is the searched location that stays the same until another search is performed
 * @param {*} coords
 */
function addSearchedMarker(coords) {
    let searched = new google.maps.Marker({
        position: coords
    });
    searched.setMap(map);
}

function setIconsOnTheMap(response) {
    if (markers !== undefined) {
        for (let i = 0; i < markers.length; i++) {
            markers[i].setMap(null);
        }
    }

    let locationsArray = response.locations;

    // region Sneaky call to show hide zero results alert
    if (locationsArray.length === 0) {
        $zeroAlert.show();
    } else {
        $zeroAlert.hide();
    }
    // endregion

    let coordinates;

    markers = locationsArray.map(function (location, i) {
        coordinates = {lat: parseFloat(location.latitude), lng: parseFloat(location.longitude)};

        let icon = {
            url: location.images.icon,
            scaledSize: new google.maps.Size(32, 32),
            origin: new google.maps.Point(0, 0),
            anchor: new google.maps.Point(16, 16)
        };

        let marker = new google.maps.Marker({position: coordinates, icon: icon});

        // region Click Event
        google.maps.event.addListener(marker, 'click', (function (marker) {
            return function () {
                infoWindow.setContent(location.block);
                infoWindow.open(map, marker);
                $('#redraw').val(0);
            }
        })(marker, i));
        // endregion

        return marker;
    });

    for (let l = 0; l < markers.length; l++) {
        markers[l].setMap(map);
    }

    $('.js-results-count').html(markers.length);
}

/**
 * used to get data from the server and update the map and filters
 */
function submitRequest(url) {
    $('#loading-map').show();

    // region Build URL
    url = url === undefined ? $('.js-map-search').attr('data-url') : url;

    if (url.indexOf('lat') === -1) {
        if (url.indexOf('?') !== -1) {
            url += '&';
        } else {
            url += '?';
        }

        url += 'lat=' + $('input[name="latitude"]').val();
        url += '&lng=' + $('input[name="longitude"]').val();
        url += '&ne_lat=' + $('input[name="ne_latitude"]').val();
        url += '&ne_lng=' + $('input[name="ne_longitude"]').val();
        url += '&sw_lat=' + $('input[name="sw_latitude"]').val();
        url += '&sw_lng=' + $('input[name="sw_longitude"]').val();
        url += '&area=' + $('input[name="area"]').val();
    }
    // endregion

    // region Make request to get map data
    $.ajax({
        method: 'get',
        url: url,
        dataType: 'json',
        headers: {
            'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
        },
        success: function (response) {
            //  update the map and icons
            setIconsOnTheMap(response);

            //  update the side menu filters
            if(response.filterBar !== '') {
                $('#filter-items').html(response.filterBar);
                $('.filter-bar').removeClass('d-none');
            }

            //  take down the loading div
            $('#loading-map').hide();
        },
        error: function (xhr, ajaxOptions, thrownError) {
            //  take down the loading div
            $('#loading-map').hide();
        }
    });
    // endregion
}

// TODO Show error and don't redirect
function showGeoError(error, redirectTo) {
    redirectTo = redirectTo === undefined ? null : redirectTo;

    let x;
    switch (error.code) {
        case error.PERMISSION_DENIED:
            x = "User denied the request for Geolocation.";
            break;
        case error.POSITION_UNAVAILABLE:
            x = "Location information is unavailable.";
            break;
        case error.TIMEOUT:
            x = "The request to get user location timed out.";
            break;
        case error.UNKNOWN_ERROR:
            x = "An unknown error occurred.";
            break;
    }
    // console.log(x);
    if (redirectTo === 'local-offers') {
        return window.location = localOffersUrl;
    }
}

$(document).on('click', '.js-local-search-map .js-toggle-filter, .js-local-search-map .js-remove-filter', function () {
    let url = $(this).attr('data-url');

    if (!$(this).hasClass('disabled')) {
        if (url) {
            $('.js-map-search').attr('data-url', url);

            submitRequest($(this).attr('data-url'));
        }
    }
});
